import {
  InvoiceStatus,
  TicketDiscountType,
  TicketItemType,
  TicketModifierOptionsType,
} from '../../redux/data/dataTypes';
import api from '../axios/axiosInstance';

export interface invoiceForm {
  ID: string;
  items?: TicketItemType[];
  discounts?: TicketDiscountType[];
  modifierOptions?: TicketModifierOptionsType[];
  category?: 'IN' | 'OUT' | 'DELIVERY';
  payType: 'CASH' | 'CARD' | 'BOTH' | 'CREDIT';
  type: 'PAY' | 'REFUND';
  currency: string;
  total: number;
  number: number;
  shiftId: string;
  posId: string;
  storeId?: string;
  createdAt: Date | string;
  originalInvoiceId?: string;
  customerId?: string | null;
  status?: InvoiceStatus;
  tableId?: string | null;
  name?: string;
}

export interface sendInvoiceForm {
  ID: string;
  email: string;
}

const submitInvoice = async (data: invoiceForm): Promise<any> => {
  return api.post('/invoices', data);
};

const sendInvoicePdf = async (data: sendInvoiceForm): Promise<any> => {
  return api.post('/invoices/send', data);
};

const sendInvoiceToKitchen = async (invoiceId: string): Promise<any> => {
  return api.post(`/invoices/${invoiceId}/send-to-kitchen`);
};

const removeOpenedInvoice = async (invoiceId: string): Promise<any> => {
  return api.post(`/invoices/${invoiceId}/remove-opened`);
};

const updateInvoice = async (
  invoiceId: string,
  data: Partial<Omit<invoiceForm, 'ID' | 'status' | 'shiftId' | 'posId' | 'storeId'>>
): Promise<any> => {
  return api.patch(`/invoices/${invoiceId}`, data);
};

const updateInvoiceStatus = async (invoiceId: string, status: InvoiceStatus): Promise<any> => {
  return api.patch(`/invoices/${invoiceId}/order-status`, { status });
};

export {
  removeOpenedInvoice,
  sendInvoicePdf,
  sendInvoiceToKitchen,
  submitInvoice,
  updateInvoice,
  updateInvoiceStatus,
};
